
import Glide from '@glidejs/glide'
// import 'jquery';

//import { Autoplay  }  from '@glidejs/glide/dist/glide.modular.esm'


class Carousel {

    constructor () {

        this.mobCarou = document.querySelector('.responsive');

        if (this.mobCarou != null) {
            this.caro = new Glide(this.mobCarou).mount()
        }


    }
}

export default Carousel
